/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconMedicalInformation/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconMedicalInformation({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconMedicalInformation",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "#323232",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconMedicalInformation.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-1xCDJ6': alignSelf,'--mt-2-1xCDJ6': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1xCDJ6': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1xCDJ6': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1xCDJ6': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1xCDJ6': opacity,'--w-10-1xCDJ6': typeof width === 'number' ? `${width}px` : width,'--h-11-1xCDJ6': typeof height === 'number' ? `${height}px` : height,'--f-12-1xCDJ6': fill,'--a-7-1xCDJ6': isAnimated ? animation : "none",'--sd-8-1xCDJ6': isAnimated ? strokeDashoffset : 0,'--sd-9-1xCDJ6': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconMedicalInformation.SvgPath"
  data-view-path={viewPath}
 d="M20 7h-5V4c0-1.1-.9-2-2-2h-2c-1.1 0-2 .9-2 2v3H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-9-3h2v5h-2V4zm9 16H4V9h5c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2h5v11zm-9-4H9v2H7v-2H5v-2h2v-2h2v2h2v2zm2-1.5V13h6v1.5h-6zm0 3V16h4v1.5h-4z"
 className="views-block"
/>
</svg>
{children}
</React.Fragment>)
}